import { useMutation } from "app/hooks/root-contract/mutation/use-mutation";
import stakingContract from "services/staking.contract";
import { useChainId } from "wagmi";

export const useEmergencyWithdrawMutation = () => {
  const chainId = useChainId();
  const emergencyWithdrawMutation = async () => {
    return await stakingContract.emergencyWithdrawPopulate({
      address: process.env.REACT_APP_STAKING_CONTRACT_ADDR,
      chainId: chainId,
    });
  };
  return useMutation(emergencyWithdrawMutation);
};
